import { z } from 'zod'

/***************** 콘텐츠 공유 범위 *****************/
// 서버 ContentShareScope(common/model/type). 학습지·교재·시험지를 누구와 함께 보는가
// — 선생님 개인·학원·학원 그룹. 학원은 이 어휘로 만들기 기본값도 들고 있다(AcademyDetail).
export const SHARE_SCOPE = ['TEACHER', 'ACADEMY', 'ACADEMY_GROUP'] as const

/***************** 학생 공개 범위 *****************/
// 선생님이 만든 콘텐츠를 학생에게 보이는지. 공유 범위와 달리 학생 쪽 한 축만 가른다.
export const ACCESS_MODIFIER_TO_STUDENT = ['PUBLIC', 'PRIVATE'] as const

/***************** 콘텐츠 게시 상태 *****************/
// 서버 ContentStatus(common/type). 교재·상품이 함께 쓴다. DRAFT·HIDDEN·INACTIVE 는 서버에서 hidden 이다.
export const CONTENT_STATUS = ['DRAFT', 'ACTIVE', 'HIDDEN', 'INACTIVE'] as const

export const ShareScopeSchema = z.enum(SHARE_SCOPE)
export type ShareScope = z.infer<typeof ShareScopeSchema>

export const AccessModifierToStudentSchema = z.enum(ACCESS_MODIFIER_TO_STUDENT)
export type AccessModifierToStudent = z.infer<typeof AccessModifierToStudentSchema>

export const ContentStatusSchema = z.enum(CONTENT_STATUS)
export type ContentStatus = z.infer<typeof ContentStatusSchema>
